import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import List from '../list/list'
import Button from '../button/button'

import './list-expandable.styl'
class ListExpandable extends React.Component {
    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        printable: PropTypes.bool,
        onChange: PropTypes.func,
        template: PropTypes.func.isRequired,
        collection: PropTypes.array.isRequired,
    }

    constructor(props){
        super(props);
        this.state = {
            value: props.value,
            error: false
        };
        this.remove = this.remove.bind(this)
    }

    handleChange(event) {
        let { value } = event.target
        this.setState({value})
    }

    onChange(value) {
        let { onChange = false } = this.props
        if(!onChange) {
            return
        }
        let promise = onChange(value)
        if(!promise) {
            console.log('no promise return after doing onChange methode');
            return
        }
        !promise._state && this.setState({loading: true})
        promise.then(e => setTimeout(() => {
            this.setState({loading: false, error: false})
        }, 10))
        .catch( e => this.setState({loading: false, error: true}));
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({value: nextProps.value})
    }

    add() {
        this.props.collection.push({});
        this.forceUpdate()
    }

    remove(index) {
        this.props.collection.splice(index, 1);
        this.forceUpdate()
    }

    render() {
        const { printable=true } = this.props
        if(!printable){
            return <div className="hide"></div>
        }

        const { label, className=false, collection, template, disabled } = this.props;
        let collectionRender = []
        collection.forEach((element, index) => collectionRender.push(<li>
            <div className='list-expandable-data'>{ template(element) }</div>
            <Button className='list-expandable-remove' onClick={e => this.remove(index)} icon='deleted' label='app.remove' />
        </li>))

        return <div className={"list-expandable" + (className ? ' ' + className : '')}>
            <Button className='list-expandable-add' onClick={this.add.bind(this)} icon='plus' label='app.add' />
            <List collection={collectionRender} label={label} />
        </div>
    }
}

ListExpandable.defaultProps = {
    value: ''
}

export default injectIntl(ListExpandable)

